import React from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Grid, Header } from 'semantic-ui-react';
import { hidePromoAnalysisModal, showPromoAnalysisDetailsModal } from '../../redux/actions/modals';
import DataGrid from '../shared/DataGrid';
import CollectionFilters from '../SiteInstallations/CollectionFilters';
import collections from '../../api/collections'
import DetailsButton from '../shared/DetailsButton';

class PromoAnalysisModal extends React.Component {

  state = { 
    activeRow: null,
    detailsLoading: false
  }
  
  onClose = () => this.props.hidePromoAnalysisModal();

  onRowClick = (activeRow) => this.setState({ activeRow });
  
  onDetailsClick = () => {
    this.setState({ detailsLoading: true }, () => {
      collections.getPromoCashDetails().then(
        grid => this.props.showPromoAnalysisDetailsModal(grid).then(() => this.setState({ detailsLoading: false })),
      )
    })
  }

  render() {

    const { activeRow, detailsLoading } = this.state;
    const { grid, open } = this.props.modal;

    return (
        <Modal
            open={open}
            onClose={this.onClose}
            size='large'
            closeIcon
        >
          <Modal.Header>
            <Header size="tiny">
              Promo Analysis
              <Header.Subheader>Demo CMS 2, Bristol (30004)</Header.Subheader>
            </Header>
          </Modal.Header>
          <Modal.Content className="h-100 gs-flex-container-vertical">
            <Grid className="h-100 gs-flex-container-vertical">
              <Grid.Row>
                <Grid.Column width="12">
                  <CollectionFilters 
                    {...this.props.modal}
                  />
                </Grid.Column>
                <Grid.Column width="4" textAlign="right">
                  <DetailsButton disabled={!activeRow} loading={detailsLoading} onClick={this.onDetailsClick} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="flex-stretch">
                <Grid.Column className="gs-flex-container-vertical" style={{ minHeight: "300px"}}>
                  <DataGrid
                    headings={grid.headerDef}
                    data={grid.data}
                    activeRow={activeRow}
                    rowDef={grid.rowDef}
                    hideOverflow
                    onRowClick={this.onRowClick}
                    fullHeight
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
        </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.promoAnalysisModal,
  };
};

export default connect(mapStateToProps, { showPromoAnalysisDetailsModal, hidePromoAnalysisModal })(PromoAnalysisModal);


